import React, { useCallback, useState } from 'react';

export function useToast() {
  const [toast, setToast] = useState(null);

  const show = useCallback((msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4000);
  }, []);

  const node = toast ? (
    <div
      data-testid="toast-message"
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] px-5 py-3 rounded-xl shadow-lg text-sm font-medium ${
        toast.type === 'error' ? 'bg-red-600 text-white' : 'bg-teal-600 text-white'
      }`}
    >
      {toast.msg}
    </div>
  ) : null;

  return { show, node };
}
